/*------------------------------------*\
    MODULES
\*------------------------------------*/
import ClipboardJS from "clipboard";

/*------------------------------------*\
    COPY TO CLIPBOARD
\*------------------------------------*/
class CopyToClipboard {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.inputId = self.elem.getAttribute('data-clipboard-target').replace('#', '');
        self.input = document.getElementById(self.inputId);
        self.originalText = self.elem.getAttribute('data-original-text');
        self.activeText = self.elem.getAttribute('data-active-text');
    }

    init() {
        let self = this;

        self.input.addEventListener('focus', evt => {
            self.input.select();
        });
          
        self.input.addEventListener('mouseup', evt => {
            evt.preventDefault();
        });

        const clipboard = new ClipboardJS(self.elem);

        clipboard.on('success', function (evt) {
            self.elem.textContent = self.activeText;

            evt.clearSelection();

            setTimeout(() => {
                self.elem.textContent = self.originalText;
            }, 2000);
        });
    }
}

export default CopyToClipboard;
